import { MemeItem } from '../common/scripts/carousel/types/items'
import ALL_FORTUNES from '../common/scripts/fortune_cookie/content'
import initFortuneCookie from '../common/scripts/fortune_cookie/fortune_cookie'

export const language = document.documentElement.lang

const getItems = async (language: string, dynamic: boolean) => {
  if (dynamic) {
    return await window.CarouselLoader.load<MemeItem>('fortune-cookie')
  }

  return ALL_FORTUNES[language]
}

const init = async () => {
  const blocks: HTMLElement[] = Array.from(
    document.querySelectorAll('[data-mp-content-type="fortune_cookie_widget"]')
  )

  for (const block of blocks) {
    const isDynamic = block.dataset.mpDynamic === 'true'
    const items = await getItems(language, isDynamic)

    initFortuneCookie(block, items)
  }
}

// Dynamic content loading requires async.  Need to make sure experiments have finished loading first.
if (window.experimentsLoaded) {
  // noinspection JSIgnoredPromiseFromCall
  init()
} else {
  document.addEventListener('experiment:initialized', () => {
    // noinspection JSIgnoredPromiseFromCall
    init()
  })
}
